import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles()(() => ({
	panel: {
		border: "1px solid #d1d5db",
		borderRadius: "4px",
		padding: "12px 14px",
		backgroundColor: "#fafafa",
	},
	heading: {
		fontFamily: "Roboto Condensed",
		fontWeight: "bold",
		fontSize: "13px",
		marginBottom: "6px",
		color: "#4b5563",
	},
	row: {
		fontSize: "13px",
		display: "flex",
		gap: "6px",
	},
	rowLabel: {
		fontWeight: 600,
	},
	hint: {
		fontSize: "12px",
		color: "#6b7280",
		marginTop: "8px",
	},
	empty: {
		fontStyle: "italic",
		color: "#6b7280",
		fontSize: "13px",
	},
}));

const CurrentFiltersPanel = ({ filters = [] }) => {
	const { classes } = useStyles();
	const { t } = useTranslation();
	return (
		<div>
			<div className={classes.panel}>
				<Typography className={classes.heading}>
					{t("message.currentPageFiltersUsed")}
				</Typography>
				{filters.length === 0 ? (
					<span className={classes.empty}>
						{t("message.noFiltersAppliedOnPage")}
					</span>
				) : (
					filters.map((f) => (
						<div key={f.label} className={classes.row}>
							<span className={classes.rowLabel}>{f.label}:</span>
							<span>{f.value}</span>
						</div>
					))
				)}
			</div>
			<Typography className={classes.hint}>
				{t("message.reportGeneratedWithFilters")}
			</Typography>
		</div>
	);
};

export default CurrentFiltersPanel;
